'use client'

import { type FC } from 'react'

import { Audio } from '@/components/client/audio'
import { useTranslation } from '@/hooks/client'

import type { EnvironmentData } from '../../server/product/sound-performance/types'

interface EnvironmentAudioPlayersProps {
  env: EnvironmentData
  hearingAidName: string
}

export const EnvironmentAudioPlayers: FC<EnvironmentAudioPlayersProps> = ({ env, hearingAidName }) => {
  const { t } = useTranslation()
  const players: { url: string; name: string; group: string }[] = []

  if (env.openEarAudio) {
    players.push({
      url: env.openEarAudio.url,
      name: `${env.openEarAudio.title} - ${t('lab.openEar', 'Open Ear')}`,
      group: `lab-${env.id}`,
    })
  }
  if (env.initialAudio) {
    players.push({
      url: env.initialAudio.url,
      name: `${env.initialAudio.title} - ${hearingAidName}`,
      group: `lab-${env.id}`,
    })
  }
  if (env.tunedAudio) {
    players.push({
      url: env.tunedAudio.url,
      name: `${env.tunedAudio.title} - ${hearingAidName} (${t('lab.tuned', 'Tuned')})`,
      group: `lab-${env.id}`,
    })
  }

  if (!players.length) return null

  return (
    <div className="mt-4 flex flex-col gap-2.5">
      {players.map((p) => (
        <Audio key={p.url} url={p.url} variant="bars" title={p.name} group={p.group} compact />
      ))}
    </div>
  )
}
